import { Link } from "react-router-dom";

import "../App.css";

function LoginCTA() {
  return (
    <div className="cta-block">
      <div className="cta-content">
        <div className="cta-left">
          <h2>Want to see who's at the table?</h2>
          <Link to="/register">
            <button className="btn-join">Grab your spot</button>
          </Link>
        </div>
        <div className="cta-right">
          <ul className="cta-points">
            <li>👀 See exactly who's joining each event</li>
            <li>💬 Chat with attendees before you show up</li>
            <li>🌱 First 200 members get a full year for free</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default LoginCTA;
